import { createFileRoute, useNavigate } from '@tanstack/react-router'

import {
    GRADE_CATALOG_FILTERS,
    GradeCatalogPage,
} from '@/components/tea-grades/grade-catalog-page'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/scenting-warehouse/grades',
)({
    validateSearch: GRADE_CATALOG_FILTERS.validateSearch,
    component: ScentingGradesPage,
})

// Danh mục phân loại riêng của kho lấy hương (M-39).
// Export named để test render được màn thật: autoCodeSplitting tách `component`
// khỏi route nên `Route.options.component` chỉ còn là stub rỗng.
export function ScentingGradesPage() {
    const navigate = useNavigate({ from: '/scenting-warehouse/grades' })
    return (
        <GradeCatalogPage
            kind="scenting"
            search={Route.useSearch()}
            onSearchChange={(next, opts) =>
                void navigate({
                    search: () => next,
                    replace: opts?.replace ?? false,
                })
            }
        />
    )
}
